var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"convention-body"},[_c('typo',{attrs:{"name":"cc-body"},domProps:{"innerHTML":_vm._s(_vm.body)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }